export enum SicknessType {
    PHYSICAL_ILLNESS = 'Physical illness',
    MENTAL_HEALTH = 'Mental health',
}